console.log('EAN labels JS geladen');

const SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTgqMsIpZnnpAvRRbTYxFz6-y1qouGFoKkuVbV6ZsplvtZmSGiyDaS0PMQJZOQdY__s-4txiXDHoXLa/pub?gid=59670626&single=true&output=csv';

// DOM-Elemente holen (Script wird nach dem HTML geladen)
const searchInput   = document.getElementById('search');
const resultsDiv    = document.getElementById('results');
const selectionDiv  = document.getElementById('selection');
const productInfoP  = document.getElementById('product-info');
const labelTitleDiv = document.getElementById('label-title');
const labelSkuDiv   = document.getElementById('label-sku');
const printBtn      = document.getElementById('print-btn');
const quantityInput = document.getElementById('quantity');

let products = [];
let selectedProduct = null;

// CSV laden und parsen
function loadProducts() {
  if (!resultsDiv) {
    console.warn('EAN-Label-UI nicht gefunden – vermutlich auf anderer Seite.');
    return;
  }
  resultsDiv.textContent = 'Lade Produktliste aus Google Sheets…';

  Papa.parse(SHEET_URL, {
    download: true,
    header: true,
    skipEmptyLines: true,
    complete: function(results) {
      console.log('CSV geladen, Zeilen:', results.data.length);
      products = results.data
        .filter(row => row.ean && row.ean.trim() !== '')
        .map(row => ({
          name: row.name || '',
          sku:  row.sku  || '',
          ean:  row.ean  || ''
        }));
      console.log('Produkte mit EAN:', products.length);

      if (products.length === 0) {
        resultsDiv.textContent = 'Keine Produkte gefunden. Bitte Sheet prüfen.';
      } else {
        resultsDiv.textContent = 'Bitte Suchbegriff eingeben…';
      }
    },
    error: function(error) {
      console.error('Fehler bei Papa.parse:', error);
      resultsDiv.textContent = 'Fehler beim Laden der Daten. Bitte Link prüfen.';
    }
  });
}

function renderResults(list) {
  resultsDiv.innerHTML = '';
  if (!searchInput.value.trim()) {
    resultsDiv.textContent = 'Bitte Suchbegriff eingeben…';
    return;
  }
  if (list.length === 0) {
    resultsDiv.textContent = 'Keine Treffer';
    return;
  }
  list.forEach(p => {
    const div = document.createElement('div');
    div.className = 'result-item';
    div.textContent = `${p.name} | SKU: ${p.sku} | EAN: ${p.ean}`;
    div.onclick = () => selectProduct(p);
    resultsDiv.appendChild(div);
  });
}

function selectProduct(p) {
  selectedProduct = p;
  selectionDiv.style.display = 'block';
  productInfoP.textContent = `${p.name} (SKU: ${p.sku}, EAN: ${p.ean})`;

  if (labelTitleDiv) labelTitleDiv.textContent = p.name;
  if (labelSkuDiv)   labelSkuDiv.textContent   = `SKU ${p.sku}`;

  JsBarcode("#barcode", p.ean, {
    format: "ean13",
    displayValue: true,
    fontSize: 10,
    height: 35,   // Barcode flacher
    margin: 0
  });
}

// Events nur setzen, wenn die Elemente existieren (nur auf der EAN-Seite)
if (searchInput) {
  // Tipp-Ereignis
  searchInput.addEventListener('input', () => {
    const q = searchInput.value.toLowerCase();
    const filtered = products.filter(p =>
      (p.name && p.name.toLowerCase().includes(q)) ||
      (p.sku  && p.sku.toLowerCase().includes(q))  ||
      (p.ean  && p.ean.includes(q))
    );
    renderResults(filtered);
  });

  // ENTER → wenn 1 Treffer → automatisch auswählen
  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const q = searchInput.value.toLowerCase();
      const filtered = products.filter(p =>
        (p.name && p.name.toLowerCase().includes(q)) ||
        (p.sku  && p.sku.toLowerCase().includes(q))  ||
        (p.ean  && p.ean.includes(q))
      );

      if (filtered.length === 1) {
        e.preventDefault();
        selectProduct(filtered[0]);
      }
    }
  });
}

if (printBtn) {
  printBtn.addEventListener('click', () => {
    if (!selectedProduct) return;
    const qty = parseInt(quantityInput.value, 10) || 1;

    const printWindow = window.open('', 'PRINT', 'height=400,width=600');
    printWindow.document.write(`
  <html>
  <head>
    <title>${selectedProduct.name} ${selectedProduct.sku}</title>
    <style>
      @media print {
        /* Seite exakt so groß wie das Label */
        @page {
          size: 50mm 30mm;
          margin: 0;
        }
      }
      body {
        margin: 0;
        padding: 0;
        font-family: sans-serif;
      }
      .label {
        width: 50mm;
        height: 30mm;
        box-sizing: border-box;
        padding: 2mm;
      }
      .label-title {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 2px;
        text-align: center;
      }
      .label-sku {
        font-size: 11px;
        margin-bottom: 4px;
        text-align: center;
      }
      .barcode {
        width: 100%;
      }
    </style>
  </head>
  <body>
`);


    for (let i = 0; i < qty; i++) {
      printWindow.document.write(`
        <div class="label">
          <div class="label-title">${selectedProduct.name}</div>
          <div class="label-sku">SKU ${selectedProduct.sku}</div>
          <svg class="barcode"></svg>
        </div>
      `);
    }

    printWindow.document.write(`
      <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"><\/script>
      <script>
        const ean = "${selectedProduct.ean}";
        document.querySelectorAll('.barcode').forEach(el => {
          JsBarcode(el, ean, {
            format: "ean13",
            displayValue: true,
            fontSize: 10,
            height: 35,
            margin: 0
          });
        });
        window.onload = function() {
          window.print();
          window.close();
        };
      <\/script>
      </body>
      </html>
    `);
    printWindow.document.close();
  });



}

// direkt starten
loadProducts();
